export default "__VITE_ASSET__DTTxRWeC__"